import React from 'react';
import { setCart, setCheckoutCart } from 'state/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';

export const CartItemRemove = ({ item, index }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const cart = useSelector(store => store.cart)
    const checkoutCart = useSelector(store => store.checkout_cart)

    const handleRemoveClick = () => {
        Modal.confirm({
            title: t("Strategy deletion confirmation"),
            content: (<p>{t('confirmation.deletion_from_cart', { name: item.name })}</p>),
            okText: "Confirm",
            okButtonProps: {'data-test-id': 'cart-modal-confirm'},
            cancelButtonProps: {'data-test-id': 'cart-modal-cancel'},
            onOk() {
                const cartItem = cart.filter(cart_item => parseInt(cart_item.id) !== parseInt(item.id));
                dispatch(setCart(cartItem));

                const { [item.id]: _removed, ...remainingCheckoutCart } = checkoutCart;
                dispatch(setCheckoutCart(remainingCheckoutCart));
            },
        });
    }

    return (
        <button onClick={handleRemoveClick} type="button" data-test-id={"cart-item-rm-btn-" + index} className="cart-item-remove ml-auto"></button>
    )
}

export const CartItemSelect = ({ item, index }) => {
    const dispatch = useDispatch()
    const checkoutCart = useSelector(store => store.checkout_cart)

    const selectItem = (id) => {
        dispatch(setCheckoutCart({
            ...checkoutCart,
            [id]: { ...checkoutCart[id], checked: !checkoutCart[id].checked }
        }))
    }

    if ( item?.disabled ) return null

    return (
        <div className="input-checkbox">
            <label>
                <input onChange={() => { selectItem(item.id) }} name={"cart-item-" + index}
                    checked={item.checked} type="checkbox" data-test-id={"cart-item-check-" + index} />
                <i data-test-id={"cart-item-check-click-" + index}></i>
            </label>
        </div>
    )
}
